import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, select, Store} from '@ngrx/store';
import {flatMap, map, withLatestFrom} from 'rxjs/operators';
import * as actionsUi from './mandantenverwaltung-technik.actions.ui';
import {PageState} from './mandantenverwaltung-technik.reducer';
import {UuidService} from '@orga-app/providers/uuid.service';
import {KommunikationConfigTypes, PostTestMailSendenAction, TestMailRequest} from '@orga-app/clients/kommunikation';
import {GetMandantConfigAction, PostMandantConfigSpeichernAction} from '../../../client-ngrx/api';
import {MandantenConfigTypes} from '../../../client-constants';
import AZURE_AD_MANDANT_OPTIONS = MandantenConfigTypes.AZURE_AD_MANDANT_OPTIONS;
import SMTP_MANDANT_OPTIONS = KommunikationConfigTypes.SMTP_MANDANT_OPTIONS;
import TROUBLE_TICKET_MANDANT_OPTIONS = KommunikationConfigTypes.TROUBLE_TICKET_MANDANT_OPTIONS;
import {getAzureAdConfig, getSMTPConfig, getTroubleTicketConfig} from './mandantenverwaltung-technik.selectors';
import {MandantConfigRequest} from '../../../clients/api';


@Injectable()
export class MandantenverwaltungTechnikPageUiEffects {

    @Effect()
    pageReset$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET)
        , flatMap(() => {
            return [new GetMandantConfigAction(AZURE_AD_MANDANT_OPTIONS + ';' +
                SMTP_MANDANT_OPTIONS + ';' +
                TROUBLE_TICKET_MANDANT_OPTIONS)];
        })
    );

    @Effect()
    technischeZugriffeSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.TECHNISCHE_ZUGRIFFE_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getAzureAdConfig)), this.store.pipe(select(getSMTPConfig)), this.store.pipe(select(getTroubleTicketConfig)))
        , map(([x, azureAd, smtp, troubleTicket]) => {
            const configs: { [key: string]: any } = {};

            if (azureAd !== null) {
                configs['azuread'] = azureAd;
            }
            if (smtp !== null) {
                configs['kom-smtp'] = smtp;
            }
            if (troubleTicket !== null) {
                configs['kom-troubleticket'] = troubleTicket;
            }

            const request: MandantConfigRequest = {
                configs,
            };
            return new PostMandantConfigSpeichernAction(request);
        })
    );

    @Effect()
    smtpTestmailSenden$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.SMTP_TESTMAIL)
        , withLatestFrom(this.store.pipe(select(getSMTPConfig)))
        , map(([x, smptConfig]) => {
            return new PostTestMailSendenAction(<TestMailRequest>{
              smtpMandantOptions: smptConfig
            });
        })
    );


    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private uuid: UuidService) {
    }
}
